export default __webpack_public_path__ + "static/media/pantry2-after2-1920w.80baa052.avif";